/**
 * CorrectionReasonModal — Batch #14.331 : motif obligatoire pour annuler le report d'une pièce dont l'écriture est déjà au grand livre.
 * L'écriture est annulée (statut « annulée », trace conservée) et la correction s'inscrit au journal des corrections.
 */
import { useState } from "react";
import { Btn, Modal, inputCls } from "@/pages/admin/comptabilite/_shared";

export default function CorrectionReasonModal({ title, detail, onClose, onConfirm, busy }) {
  const [reason, setReason] = useState("");
  const ok = reason.trim().length >= 5;
  return (
    <Modal title={title} sub="L'écriture au grand livre sera annulée (statut « annulée », elle reste visible au grand livre comme trace) et la pièce redeviendra modifiable. Le motif est conservé au journal des corrections." onClose={onClose} testId="correction-reason-modal"
      footer={<><Btn tone="slate" onClick={onClose} testId="correction-cancel">Fermer</Btn><Btn tone="rose" busy={busy} disabled={!ok} onClick={() => onConfirm(reason.trim())} testId="correction-confirm">Annuler le report et corriger</Btn></>}>
      {detail && <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg p-2 mb-3" data-testid="correction-detail">{detail}</p>}
      <label className="text-xs font-semibold text-slate-700">Motif de la correction * <span className="font-normal text-slate-500">(5 caractères minimum)</span></label>
      <textarea rows={3} className={`${inputCls} mt-1`} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="ex. Mauvaise date saisie (2062 au lieu de 2026)" data-testid="correction-reason" autoFocus />
    </Modal>
  );
}
